import axios from "axios";
import CryptoJS from "crypto-js";

const signature = CryptoJS.HmacSHA256(
    "dattainfra@123@@@@",
    "MySuperSecret123"
).toString();

const api = axios.create({
    baseURL: 'https://app.dattainfra.com',
     // baseURL: 'http://192.168.0.109:4400',
    //baseURL: 'http://localhost:50000/',
    headers: {
        "Content-Type": "application/json",
        "x-secret-key": signature,
    },
});

export default api;

